// C:\Projects\texe-web\src\pages\BlockedUsers.tsx
import { useEffect, useState } from "react";
import { apiDelete, apiGet, API_BASE_URL } from "../lib/api";
import Avatar from "../components/Avatar";
import ImageModal from "../components/ImageModal";
import { Link } from "react-router-dom";

type Row = {
  user: {
    _id: string;
    username: string;
    email?: string;
    // backend destekliyorsa gelir; yoksa null/undefined olur
    avatarUrl?: string | null;
    avatarUrlSmall?: string | null;
  };
  since: string;
};

function toAbs(u?: string | null): string | undefined {
  if (!u) return undefined;
  return u.startsWith("/") ? `${API_BASE_URL}${u}` : u;
}

export default function BlockedUsers() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);

  // Modal state (avatar büyük gösterim)
  const [modalSrc, setModalSrc] = useState<string | null>(null);
  const [modalAlt, setModalAlt] = useState<string>("");

  async function load() {
    setErr(null);
    const r = await apiGet<{ ok: true; items: Row[] }>("/api/blocks/list");
    setRows(r.items);
  }

  useEffect(() => {
    load()
      .catch((e) => setErr(e?.message || "Liste alınamadı"))
      .finally(() => setLoading(false));
  }, []);

  async function unblock(id: string) {
    try {
      setBusyId(id);
      await apiDelete<{ ok: true }>(`/api/blocks/${id}`);
      await load();
    } catch (e: any) {
      setErr(e?.message || "Engel kaldırılamadı");
    } finally {
      setBusyId(null);
    }
  }

  function openAvatar(row: Row) {
    const bigAbs = toAbs(row.user.avatarUrl) ?? toAbs(row.user.avatarUrlSmall) ?? null;
    if (!bigAbs) return;
    setModalSrc(bigAbs);
    setModalAlt(row.user.username);
  }

  if (loading) return <div style={{ padding: 24 }}>Yükleniyor...</div>;

  return (
    <div style={{ padding: 24, maxWidth: 720, margin: "0 auto" }}>
      <h2 style={{ marginBottom: 12 }}>Engellenenler</h2>
      {err && <p style={{ color: "crimson" }}>{err}</p>}

      {rows.length === 0 ? (
        <p>Hiç kullanıcı engellemedin.</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {rows.map((r) => {
            const smallAbs =
              toAbs(r.user.avatarUrlSmall) ?? toAbs(r.user.avatarUrl) ?? undefined;
            const isBusy = busyId === r.user._id;

            return (
              <li
                key={r.user._id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "48px 1fr auto",
                  gap: 12,
                  padding: "10px 0",
                  borderBottom: "1px solid #2c2c2c",
                  alignItems: "center",
                }}
              >
                {/* Avatar */}
                <div
                  onClick={() => openAvatar(r)}
                  title={smallAbs ? "Büyüt" : undefined}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: smallAbs ? "pointer" : "default",
                  }}
                >
                  <Avatar src={smallAbs} alt={r.user.username} size={40} />
                </div>

                {/* Kullanıcı + tarih */}
                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      flexWrap: "wrap",
                    }}
                  >
                    <strong>
                      <Link
                        to={`/u/${encodeURIComponent(r.user.username)}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        @{r.user.username}
                      </Link>
                    </strong>
                    <span style={{ opacity: 0.7 }}>•</span>
                    <span style={{ opacity: 0.8, whiteSpace: "nowrap" }}>
                      {new Date(r.since).toLocaleString()}
                    </span>
                  </div>
                </div>

                {/* Aksiyon */}
                <div>
                  <button onClick={() => unblock(r.user._id)} disabled={isBusy}>
                    {isBusy ? "Kaldırılıyor…" : "Engeli Kaldır"}
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}

      {/* Büyük avatar modalı */}
      <ImageModal
        open={!!modalSrc}
        src={modalSrc ?? undefined}
        alt={modalAlt || "avatar"}
        caption={modalAlt ? `@${modalAlt}` : undefined}
        onClose={() => setModalSrc(null)}
      />
    </div>
  );
}
